import React, { useCallback, useEffect, useState } from 'react';
const names = ['Mark R.', 'Julia B.', 'Alex C.', 'Frances M.', 'Matt S.', 'Claire L.', 'Liam P.', 'Valerie D.'];
const cities = ['Sydney', 'Florida', 'Madrid', 'Toronto', 'London', 'Dubai', 'Berlin', 'Melbourne'];
const products = ['Ice Hockey Ready', 'Ice Hockey Ready', 'Ice Hockey Ready: The Ultimate Pro Bundle', 'Ice Hockey Ready'];
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchaseNotification() {
  const [notification, setNotification] = useState<{
    name: string;
    city: string;
    product: string;
    time: string;
  } | null>(null);
  const show = useCallback(() => {
    setNotification({
      name: randomItem(names),
      city: randomItem(cities),
      product: randomItem(products),
      time: String(Math.floor(Math.random() * 15) + 2)
    });
    setTimeout(() => {
      setNotification(null);
      setTimeout(show, Math.floor(Math.random() * 25000) + 25000);
    }, 4000);
  }, []);
  useEffect(() => {
    let firstTimer: number | null = null;
    let idleHandle: any = null;
    firstTimer = window.setTimeout(() => {
      const w = window as any;
      const idle = w.requestIdleCallback || ((cb: () => void) => setTimeout(cb, 200));
      idleHandle = idle(show);
    }, 15000);
    return () => {
      if (firstTimer != null) clearTimeout(firstTimer);
      const w = window as any;
      if (idleHandle && w.cancelIdleCallback) {
        try {
          w.cancelIdleCallback(idleHandle);
        } catch {}
      }
    };
  }, [show]);
  if (!notification) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-brand-card rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)] border border-brand-border p-3 max-w-[260px] pointer-events-none" data-id="element-235">
      <div className="flex items-start gap-3" data-id="element-236">
        <span className="text-brand-accent text-sm mt-0.5" data-id="element-237">✅</span>
        <div data-id="element-238">
          <div className="text-[10px] font-bold text-brand-accent uppercase tracking-widest mb-1" data-id="element-239">
            Verified Purchase
          </div>
          <div className="text-xs text-white leading-tight mb-0.5" data-id="element-240">
            <span className="font-bold" data-id="element-241">{notification.name}</span> from{' '}
            {notification.city}
          </div>
          <div className="text-[11px] text-white/70 leading-tight mb-1.5" data-id="element-242">
            just bought{' '}
            <span className="font-bold text-white" data-id="element-243">{notification.product}</span>{' '}
            🏒
          </div>
          <div className="text-[10px] text-white/60 italic font-medium" data-id="element-244">
            {notification.time} minutes ago
          </div>
        </div>
      </div>
    </div>;
}